<template>
  <div class="block sm:flex gap-0 sm:gap-10 mt-14">
    <!-- Single project left section details -->
    <div class="w-full sm:w-1/3 text-left">
      <!-- Single project objectives -->
      <div class="mb-7">
        <p class="font-general-medium text-2xl text-ternary-dark dark:text-ternary-light mb-2">
          {{ $t('projectRole') }}
        </p>
        <p class="font-general-regular text-primary-dark dark:text-ternary-light">
          {{ projectInfo.projectRole }}
        </p>
      </div>
      <!-- Single project technologies -->
      <div class="mb-7">
        <p class="font-general-medium text-2xl text-ternary-dark dark:text-ternary-light mb-2">
          {{ $t('projectTool') }}
        </p>
        <p class="font-general-regular text-primary-dark dark:text-ternary-light">
          {{ projectInfo.technologies.techs }}
        </p>
      </div>
      <!-- Single project url -->
      <div class="mb-7">
        <p class="font-general-medium text-2xl text-ternary-dark dark:text-ternary-light mb-2">
          {{ $t('projectUrl') }}
        </p>
        <a :href="projectInfo.url.link" target="_blannk">
          <p class="font-general-regular text-primary-dark dark:text-ternary-light">
            {{ projectInfo.url.link }}
          </p>
        </a>
      </div>
    </div>
    <!-- Single project right section details -->
    <div class="w-full sm:w-2/3 text-left mt-10 sm:mt-0">
      <p class="font-general-medium text-primary-dark dark:text-primary-light text-2xl font-bold mb-7">
        {{ $t('projectChallenge') }}
      </p>
      <p v-for="projectDetail in projectInfo.projectDetails" :key="projectDetail.id"
        class="font-general-regular mb-5 text-lg text-ternary-dark dark:text-ternary-light">
        {{ projectDetail.details }}
      </p>
    </div>
  </div>
</template>

<script>
import feather from 'feather-icons';

export default {
  props: ['projectInfo'],

  mounted() {
    feather.replace();
  },
  updated() {
    feather.replace();
  },
};
</script>